import Router from 'skeleton-router';

const router = new Router();

const doc = document;
const body = doc.querySelector('body');

const adminBtn = doc.getElementById('admin-btn');
const navLinks = body.querySelectorAll('.nav-link');

const collapseHeaderAtYScroll = 200;
const isCollapsedClass = 'is-collapsed';
const isScrollClass = 'is-scrolled';
const hasMenuClass = 'has-menu';
const expandedClass = 'expanded';

const addClass = (element, className) => {
    element.classList.add(className || router.a);
};

const removeClass = (element, className) => {
    element && element.classList.remove(className || router.a);
};

const resetMenuItems = () => {
    if (expanded) {
        removeClass(expanded, expandedClass);
        expanded = null;
    }
};

const resetMenu = () => {
    removeClass(body, hasMenuClass);
    resetMenuItems();
};

const animationObserver = new IntersectionObserver(function (e) {
    for (let i = 0; i < e.length; i++) {
        if (e[i].isIntersecting) {
            const item = e[i].target;

            const animation = item.dataset.animation;
            const delay = item.dataset.animationDelay;

            if (animation) {
                addClass(item, animation);

                if (delay) {
                    item.style.animationDelay = delay;
                }
            }

            animationObserver.unobserve(item);
        }
    }
}, {threshold: [0]});

let isHeaderCollapsed = false;
let isScrolled = false;
let lastYScroll = 0;

let expanded = null;

let x = 0;
let y = 0;
let yPos = 0;

doc.querySelectorAll('.menu-toggle').forEach((item) => {
    item.addEventListener('click', () => {
        const isMobile = window.innerWidth < 1024;

        if (body.classList.contains(hasMenuClass)) {
            resetMenu();

            if (isMobile) {
                window.scrollTo(0, yPos)
            }
        } else {
            if (isMobile) {
                yPos = window.scrollY;
                window.scrollTo(0, 0);
            }

            addClass(body, hasMenuClass);
        }
    });
});

// Aside links.
navLinks.forEach((link) => {
    const hasSubmenu = link.closest('.submenu') !== null,
        i = hasSubmenu ? ++y : ++x;

    if (!hasSubmenu) {
        y = 0;
    }

    link.style.transitionDelay = (i * 100) + 'ms';

    link.addEventListener('click', (e) => {
        const parent = link.parentNode,
            submenu = parent.getElementsByClassName('submenu')[0];

        if (submenu && parent !== expanded) {
            resetMenuItems();
            addClass(parent, expandedClass);
            expanded = parent;
            e.preventDefault();
        }
    });
});

router.onUnhandledClick = () => {
    router.scrollTo(0);
    resetMenu();
}

router.afterRender = () => {
    const animateClass = '.animate';
    let currentVideo;

    // Reset body, to remove menu class
    removeClass(body, hasMenuClass);

    // Tabs.
    router.main.querySelectorAll('.tabs').forEach(wrap => {
        const tabs = wrap.querySelectorAll('.tab');

        tabs.forEach(tab => {
            tab.querySelector('.tab-toggle').addEventListener('click', () => {
                tabs.forEach(sibling => {
                    if (sibling !== tab) {
                        removeClass(sibling);
                    }
                });

                tab.classList.toggle('active');
            });
        });
    })

    // Videos.
    router.main.querySelectorAll('.video').forEach(btn => {
        btn.addEventListener('click', () => {
            resetVideo();

            currentVideo = btn.nextElementSibling;
            currentVideo.parentElement.classList.add('has-video');
            currentVideo.src = btn.dataset.iframeSrc;
            currentVideo.style.display = 'block';
        });
    });

    function resetVideo() {
        if (currentVideo) {
            currentVideo.parentElement.classList.remove('has-video');
            currentVideo.src = '';
            currentVideo.style.display = 'none';
        }
    }

    setTimeout(() => {
        // Give some time to get all animate elements.
        doc.querySelectorAll(animateClass).forEach(image => animationObserver.observe(image));
    }, 1);

    resetMenu();
}

// Scroll.
window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;

    if (window.innerWidth > 767) {
        if (!isHeaderCollapsed && scrollY > lastYScroll && scrollY > collapseHeaderAtYScroll) {
            addClass(body, isCollapsedClass);
            isHeaderCollapsed = true;

        } else if (isHeaderCollapsed && scrollY < lastYScroll) {
            removeClass(body, isCollapsedClass);
            isHeaderCollapsed = false;
        }

        if (scrollY > collapseHeaderAtYScroll) {
            if (!isHeaderCollapsed && scrollY > lastYScroll) {
                addClass(body, isCollapsedClass);
                isHeaderCollapsed = true;
            }

            if (!isScrolled) {
                addClass(body, isScrollClass);
                isScrolled = true;
            }

        } else {
            if (isHeaderCollapsed) {
                removeClass(body, isCollapsedClass);
                isHeaderCollapsed = false;
            }

            if (isScrolled) {
                removeClass(body, isScrollClass);
                isScrolled = false;
            }
        }

        lastYScroll = scrollY;
    }
});

// Admin.
if (adminBtn) {
    adminBtn.addEventListener('click', (e) => {
        body.classList.toggle('is-admin');
        removeClass(body, hasMenuClass);
        e.preventDefault();
    });
}

router.afterRender();

export default class Site {
    // noinspection JSUnusedGlobalSymbols
    setMenuItems(ids) {
        navLinks.forEach((el) => {
            for (let i = 0; i < ids.length; i++) {
                if (el.id === `nav-${ids[i]}`) {
                    addClass(el);
                    return;
                }
            }

            removeClass(el);
        });
    }
}